import {reactive, watch} from "vue";

class App {
    readonly active = reactive({theme: {dark: false}})

    constructor() {
        this.active.theme.dark = localStorage.getItem("theme") === "dark"
        watch(() => this.active.theme.dark, (theme) => localStorage.setItem("theme", theme ? "dark" : "light"))
    }
}

export default new App()